import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Dropdown from '@aytm/lib/rfd-ui/components/basic/dropdown'

import style from '@aytm/app/stats/page/comments/styles/dropdown.module.scss'

let updateTimer = null

const SettingsDropdown = ({ root, itemRef, buttonRef, options, warning }) => {
  const dropdownRef = useRef(null)

  const resizeObserverRef = useRef(null)

  const updateDropdownPosition = (repeat = false) => {
    if (!dropdownRef.current) return

    const buttonRect = buttonRef.current.getBoundingClientRect()
    const dropdownRect = dropdownRef.current.getBoundingClientRect()

    const scrollTop = window.scrollY || document.documentElement.scrollTop
    const innerHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight

    dropdownRef.current.style.top =
      innerHeight < buttonRect.top + buttonRect.height + dropdownRect.height
        ? `${scrollTop + buttonRect.top - dropdownRect.height}px`
        : `${scrollTop + buttonRect.top + buttonRect.height}px`
    dropdownRef.current.style.left = `${buttonRect.left}px`

    updateTimer && clearTimeout(updateTimer)
    if (repeat) {
      updateTimer = setTimeout(() => {
        if (!dropdownRef.current) return

        updateDropdownPosition()
      }, 100)
    }
  }
  const updateDropdownPositionHandler = () => updateDropdownPosition(true)

  useEffect(() => () => updateTimer && clearTimeout(updateTimer), [])

  useEffect(
    () => updateDropdownPosition(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [options]
  )

  useEffect(() => {
    updateDropdownPosition()

    window.addEventListener('scroll', updateDropdownPositionHandler)
    window.addEventListener('resize', updateDropdownPositionHandler)

    root.addEventListener('scroll', updateDropdownPositionHandler)

    resizeObserverRef.current ||= new ResizeObserver(() => updateDropdownPosition())
    if (itemRef.current) resizeObserverRef.current.observe(itemRef.current)

    return () => {
      window.removeEventListener('scroll', updateDropdownPositionHandler)
      window.removeEventListener('resize', updateDropdownPositionHandler)

      root.removeEventListener('scroll', updateDropdownPositionHandler)

      resizeObserverRef.current.disconnect()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Dropdown className={style['settings-dropdown']} dropdownRef={dropdownRef} width="auto" opened={true}>
      {() => (
        <>
          {warning ? <div className={style['settings-dropdown-warning']}>{warning}</div> : null}
          <ul className={style['settings-dropdown-options']}>
            {options.map((option, idx) => (
              <li
                key={`dropdown-option-${idx}`}
                className={classNames(style['settings-dropdown-option'], {
                  [style['settings-dropdown-option-disabled']]: option.disabled
                })}
                onClick={option.onClick}
              >
                {option.icon ? <i className={option.icon} /> : null}
                <span dangerouslySetInnerHTML={{ __html: option.label }}></span>
                {option.status ? (
                  <span className={style['settings-dropdown-option-status']}>{option.status}</span>
                ) : null}
              </li>
            ))}
          </ul>
        </>
      )}
    </Dropdown>
  )
}

SettingsDropdown.propTypes = {
  root: PropTypes.any,
  itemRef: PropTypes.any,
  buttonRef: PropTypes.any,
  options: PropTypes.array,
  warning: PropTypes.string,
  opened: PropTypes.bool
}

SettingsDropdown.displayName = 'SettingsDropdown'

export default SettingsDropdown
